import { message } from 'antd'
import type { NamePath } from 'antd/es/form/interface'

interface FormErrorInfo {
  errorFields: { name: NamePath; errors: string[] }[]
}

/**
 * Form.onFinishFailed handler for the long admin forms: a validation failure used to be
 * silent whenever the invalid field was off-screen, so surface the first error in a toast.
 */
export const notifyFormErrors = ({ errorFields }: FormErrorInfo) => {
  const count = errorFields.length
  if (!count) return
  const first = errorFields[0]?.errors?.[0]
  const detail = first ? `: ${first}` : ''
  message.error(`Please check ${count} invalid field${count > 1 ? 's' : ''}${detail}`)
}
